var EImageType = /* @__PURE__ */ ((EImageType2) => {
  EImageType2["UGC"] = "UGC Image";
  EImageType2["VIDEO"] = "video";
  EImageType2["ON_BODY"] = "On Body Image";
  EImageType2["PRODUCT"] = "Product Image";
  EImageType2["DETAIL"] = "Detail Image";
  EImageType2["SWATCH"] = "Swatch Image";
  EImageType2["INFOGRAPHIC"] = "Infographic Image";
  return EImageType2;
})(EImageType || {});
export {
  EImageType
};
//# sourceMappingURL=shared.mjs.map
